// @flow

import React from 'react';

import {DocumentAlertBox} from './DocumentAlertBox';
import {gt} from 'app/utils/i18n';
import {getContentType} from 'app/utils/content-type';
import type {VersionableDocumentTypes} from 'app/general/types';
import {RECYCLE_BIN_URL} from 'app/urls';

type Props = {contentType: VersionableDocumentTypes, isSuperManager: boolean};

export const DocumentPutToTrashAlertBox = ({
  contentType,
  isSuperManager,
}: Props) => {
  const ct = getContentType(contentType).name;

  const trashBinLink = <a href={RECYCLE_BIN_URL}>trash bin</a>;

  return (
    <DocumentAlertBox
      type="danger"
      icon="fa-exclamation-triangle"
      title={
        isSuperManager
          ? gt('This %(ct)s was deleted', {ct})
          : gt('You no longer have access to this %(ct)s', {ct})
      }
      content={
        <div>
          {isSuperManager
            ? gt(
                'This %(ct)s may still be in the recycle bin: %(trashBinLink)s',
                {ct, trashBinLink}
              )
            : gt(
                'The %(ct)s may still be in the recycle bin. Your team manager has access to check the recycle bin',
                {ct}
              )}
        </div>
      }
    />
  );
};
